import React from 'react';

/**
 * DataOps Impact Help Content
 */
const ImpactHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Impact Analysis
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Understand the downstream impact of changes before you make them. Impact Analysis helps you assess risk, identify affected consumers, and make informed decisions about data modifications.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Dependency Mapping
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Visualize all downstream consumers:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Direct dependencies</span>: Assets that directly use your data</p>
          <p>&#8226; <span className="font-medium">Transitive dependencies</span>: Assets affected through intermediate steps</p>
          <p>&#8226; <span className="font-medium">Dependency count</span>: Total number of affected downstream assets</p>
          <p>&#8226; <span className="font-medium">Critical paths</span>: Identify high-impact dependency chains</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Change Simulation
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Preview the effects of proposed changes:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Schema changes</span>: See impact of adding, removing, or modifying columns</p>
          <p>&#8226; <span className="font-medium">Data type changes</span>: Understand compatibility with downstream systems</p>
          <p>&#8226; <span className="font-medium">Deprecation planning</span>: Identify consumers before removing assets</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Risk Assessment
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium text-red-600 dark:text-red-400">High risk</span>: Changes affecting critical business reports or production systems</p>
          <p>&#8226; <span className="font-medium text-yellow-600 dark:text-yellow-400">Medium risk</span>: Changes with moderate downstream impact</p>
          <p>&#8226; <span className="font-medium text-green-600 dark:text-green-400">Low risk</span>: Changes with minimal or isolated impact</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Impact Report
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          Generate detailed impact reports:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">Affected assets list</span>: Complete inventory of impacted items</p>
          <p>&#8226; <span className="font-medium">Owner notifications</span>: List of stakeholders to notify</p>
          <p>&#8226; <span className="font-medium">Export options</span>: Download reports for review and approval</p>
        </div>
      </div>

    </>
  );
};

export default ImpactHelp;
